import React, { useEffect, useState } from "react";
import Preloader from "../elements/Preloader";
import HelmetReact from "../elements/HelmetReact";
import HeaderOne from "../components/HeaderThree";
import AboutOne from "../components/AboutOne";
import WhyChoose from "../components/WhyChoose";
import FooterOne from "../components/FooterThree";

const About = () => {
  let [active, setActive] = useState(true);
  useEffect(() => {
    setTimeout(function () {
      setActive(false);
    }, 500);
  }, []);
  return (
    <>
      {/* Preloader */}
      {active === true && <Preloader />}

      {/* Helmet */}
      <HelmetReact title={"About"} />

      {/* HeaderFive */}
      <HeaderOne />

      {/* Breadcrumb */}
      {/* <Breadcrumb title="About Us" /> */}

      {/* GoalArea */}
      {/* <GoalArea /> */}

      {/* AboutOne */}
      <AboutOne />

      {/* ProcessThree */}
      {/* <ProcessThree /> */}

      {/* TestimonialOne */}
      {/* <div className="space">
        <TestimonialOne />
      </div> */}

      {/* CounterOne */}
      {/* <CounterOne /> */}

      {/* WhyChoose */}
      <div >
        <WhyChoose />
      </div>

      {/* Newsletter */}
      {/* <Newsletter /> */}

      {/* FooterOne */}
      <FooterOne />









    </>
  );
};

export default About;
